<template>
<v-autocomplete
  v-model="selectedCategories"
  :loading="categoriesLoading"
  :items="propCategories"
  flat
  multiple
  chips
  deletable-chips
  label="Select Categories"
  item-text="name"
  item-value="id"
></v-autocomplete>
</template>

<script>
import apiClient from "@/utils/apiClient";

export default {
  name: "CategoriesAutocomplete",
  props: {
    categories: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      required: true,
    }
  },
  
  data: function () {
    return {
      categoriesLoading: false,
      categoriesSearch: "",
  
      propCategories: Array.from(this.categories),
      selectedCategories: Array.from(this.value),
    }
  },
  
  watch: {
    value(val) {
      if (val !== this.selectedCategories)
        this.selectedCategories = Array.from(val)
    },
    propCategories(val) {
      this.$emit("update:categories", val)
    },
    selectedCategories(val) {
      this.$emit("input", val)
    }
  },
  
  mounted() {
    this.queryCategories()
  },
  
  methods: {
    queryCategories() {
      this.categoriesLoading = true;
      apiClient
        .getCategories()
        .then((response) => {
          this.propCategories = response.data.items;
          this.categoriesLoading = false;
        })
        .catch((error) => {
          console.log(error);
          this.categoriesLoading = false;
        });
    },
  },
}
</script>
